module.exports = __webpack_public_path__ + "img/krystal-marquis.5e866f60.png";